export const GraphQLServerURL = process.env.GraphQLServerURL ?? 'https://frontend-challenge.dev.cooltix.com';
